/**
 * Where the venue detail page's "back to the list" goes (BON-538).
 *
 * One answer, because there is one venue list: the per-persona `/admin/venues`
 * and `/r/:slug/venues` pages were retired in favour of the unified page, and
 * the detail page now only ever mounts beneath it.
 */

/** The unified Venues page (BON-538 phase 2). */
export const VENUES_ROUTE = '/admin/venues';
